<template>
    <div style="width: 100%;height: 30px;font-size: 14px">
        <v-layout row class="ma-0">
            <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px">{{title}}</div>
            <v-menu bottom offset-x nudge-bottom="35" rounded="2" :close-on-content-click="false" >
                <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs" style="height: 30px;width: 40px;border-radius: 2px;border: 1px solid rgba(166, 166, 166, 1);margin-left: 75px;" :style="{'background-color': currColor}">
                    </div>
                </template>
                <div style="width: 300px;border-radius: 2px;background: rgba(56, 56, 56, 1);border: 1px solid rgba(166, 166, 166, 1);">
                    <v-color-picker dark class="ma-2" mode="hexa"
                                    v-model="color"
                                    :swatches="swatches"
                                    hide-mode-switch
                                    hide-canvas
                                    hide-inputs
                                    hide-sliders
                                    show-swatches
                                    style="background-color: rgba(56, 56, 56, 1);border-radius: 2px" flat></v-color-picker>
                </div>
            </v-menu>
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: "SymbolColorPicker",
        props:["currColor","title","type"],
        data(){
            return{
                swatches: [
                    ['#FF0000', ],
                    ['#FFC800', ],
                    ['#00FF00', ],
                    ['#00FFFF', ],
                    ['#2A82E4', ],
                ],
                color:this.currColor
            }
        },
        watch:{
            color(){
                let temp
                if(this.type ==='lineColor'){
                    temp={
                        type:'lineColor',
                        color:this.color
                    }
                }else{
                    temp={
                        type:'color',
                        color:this.color
                    }
                }
                this.$emit("changeColor",temp)
            }
        }
    }
</script>

<style scoped>

</style>
